module.exports = {"230204001":"站前街道","230204002":"南浦街道","230204003":"通东街道","230204004":"光荣街道","230204005":"龙华街道","230204006":"北局宅街道","230204008":"东湖街道","230204100":"扎龙镇","230204500":"齐齐哈尔种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230204.json
// module id = 635
// module chunks = 0